import { useEffect } from 'react'

import { GIT_TAG_VERSION, GIT_VERSION } from 'gatsby-env-variables'

import { SimulateButton } from '@itau-loans-www/components'
import { useLead } from '@itau-loans-www/hooks'
import { MainLayout } from '@itau-loans-www/templates'
import { getProduct, isClient } from '@itau-loans-www/utils'
import classnames from 'classnames'

// Styles
import './landing-page.scss'

export default ({ children, className, partnerName, ...props }) => {
  const { changeLeadData } = useLead()

  const classNames = classnames('landing-layout', {
    [className]: className,
    'landing-layout--partner': partnerName,
    'landing-layout--telhaNorte': partnerName === 'telhaNorte',
    'landing-layout--assai': partnerName === 'assai',
    'landing-layout--magalu': partnerName === 'magalu',
    'landing-layout--pirelli': partnerName === 'pirelli',
    'landing-layout--carrefour': partnerName === 'carrefour',
    'landing-layout--crediffato': partnerName === 'crediffato',
    'landing-layout--atacadao': partnerName === 'atacadao'
  })

  if (isClient()) {
    window.__TAG__ = GIT_TAG_VERSION
    window.__VERSION__ = GIT_VERSION
  }

  useEffect(() => {
    const productFlow = getProduct()

    if (!partnerName || productFlow !== 'fgts') {
      changeLeadData({ partner: '' })
    }
  }, [changeLeadData, partnerName])

  return (
    <div {...props} className={classNames}>
      <MainLayout
        isLanding
        hasFooter
        hasSimulateBtn={true}
        partnerName={partnerName}
      >
        <main className="landing-content">{children}</main>
        <SimulateButton />
      </MainLayout>
    </div>
  )
}
